import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="currentColor"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.004 5.25a.74.74 0 0 0-.535.214.71.71 0 0 0-.219.53v2.38l-.667-.666a.73.73 0 0 0-1.062 0 .73.73 0 0 0 0 1.062l1.961 1.962q.226.226.522.226t.517-.23L9.479 8.77a.73.73 0 0 0 0-1.062.73.73 0 0 0-1.062 0l-.667.667V5.994a.72.72 0 0 0-.214-.53.72.72 0 0 0-.532-.214M1.5 4v8.5h11V4zm0 10q-.62 0-1.06-.441a1.45 1.45 0 0 1-.44-1.06V2.626q0-.292.11-.563.108-.27.328-.5L1.563.437A1.44 1.44 0 0 1 2.625 0h8.75q.294 0 .564.104t.498.333l1.126 1.125q.218.23.328.5.108.27.109.563V12.5q0 .618-.44 1.059-.442.44-1.06.44zm.125-11.5h10.75l-1-1h-8.75z"
    />
  </svg>
);
export default SvgArchive;
